import { useParams } from 'react-router-dom';
import { findCity } from '../../lib/serviceAreas';
import { AreaPageLayout } from '../../components/AreaPageLayout';
import { NotFoundArea } from './NotFoundArea';

export const CityPage = () => {
  const { slug } = useParams();
  const city = findCity(slug);
  if (!city) return <NotFoundArea />;
  return <AreaPageLayout kind="city" area={city} />;
};
